@if (isBrowser) {
<nz-result nzStatus="404" nzTitle="404" nzSubTitle="Sorry, the page you visited does not exist.">
    <div nz-result-extra>
        <button nz-button nzType="primary" routerLink="/">Back Home</button>
    </div>
</nz-result>
} @else {
<div class="p-5 text-center">
    <h1>404</h1>
    <p>Page Not Found</p>
</div>
}